import React from 'react';
import { Global, css } from '@emotion/react';
import { theme, ThemeConfig } from 'antd';
import { merge } from 'src/services/utils';

const { useToken } = theme;

export const useAppToken = (): ReturnType<typeof useToken> => {
    const result = useToken();

    return merge(result, {
        components: {
            Splitter: {
                splitBarDraggableSize: 0,
            }
        }
    } as ThemeConfig) as typeof result;
};

export const GlobalStyles = () => {
    const { token } = useAppToken();

    return <>
        <Global styles={css`
            html {
                --scrollbarBG: ${token.colorBgContainer};
                --thumbBG: ${token.colorTextTertiary};
            }
            body:: -webkit-scrollbar,
            div:: -webkit-scrollbar,
            aside:: -webkit-scrollbar {
                width: 16px;
            }
            body {
                margin: 0;
                font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';
                font-size: 14px;
            }
            body,
            div,
            aside {
                scrollbar-width: thin;
                scrollbar-color: var(--thumbBG) var(--scrollbarBG);
            }
            body:: -webkit-scrollbar-track,
            div:: -webkit-scrollbar-track,
            aside:: -webkit-scrollbar-track {
                background: var(--scrollbarBG);
            }
            body:: -webkit-scrollbar-thumb,
            div:: -webkit-scrollbar-thumb,
            aside:: -webkit-scrollbar-thumb {
                background-color: var(--thumbBG);
                border-radius: 6px;
                border: 3px solid var(--scrollbarBG);
            }
            .ant-layout .ant-layout-header {
                background: ${token.colorBgContainer};
            }
            .ant-menu-horizontal {
                border-bottom: none; !important
            }
            .ant-form-item .ant-form-item-label {
                display: flex;
                // flex-direction: row-reverse;
            }
            .ant-menu-inline .ant-menu-item {
                height: auto;
                white-space: normal;
            }
            .action-button {
                cursor: pointer;
                font-size: 18px;
                color: #0077B5;
            }

            .ant-list.list__work-items {
                cursor: pointer;

                .ant-list-item {
                    :hover {
                        background: ${token.colorBgContainerDisabled};
                        border-radius: 6px;
                        transition: 0.3s;
                    }
                    &.selected {
                        background: ${token['blue-1']};
                        border-radius: 6px;
                        transition: 0.3s;
                    }
                }
            }

            .ant-tabs.tabs__work-items {
                height: 100%;

                .ant-tabs-content {
                    height: 100%;
                    overflow-y: auto;

                    .ant-tabs-tabpane {
                        height: 100%;
                    }
                }
            }

            .ant-alert.top-banner {
                .ant-alert-message {
                    text-align: center;
                }
            }

            .x-markdown.x-markdown-light {
                p {
                    margin: 1em 0 !important;
                }
                li {
                    margin: 0 !important;
                }
            }
        `}
        />
    </>;
};
